/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/losgehtsberlin/"

const losgehtsberlin: CommunityData = {
  code: "losgehtsberlin",
  inviteCode: "losgehtsberlin",
  name: "Los Geht's Berlin",
  thumbnail: "",
  favicon: "",
  waitlist: true,
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ber-030`,
  socials: {},
  styles: {
    global: {
      mobileOnly: true,
      counterColor: "#000000",
      logo: {
        src: "https://media.werz.at/community/icon/cmnysjqll00009kz1l03i58xf.png?uploadTime=1777276917981&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[127px] h-[85px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#fff8eb",
      asideBg: "#fff8eb",
      asideStyles: "border-r border-[#000000]",
      contentBg: "#fff8eb",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['CircularStdBook']",
      primaryButton:
        "bg-[#000000] border border-[#ffffff] rounded-lg px-[18px] py-[18px] !text-[#fff8eb] font-['OCRATributeW01-RegularMonoRegular'] !text-[16px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-[#000000]",
      separator: "#000000",
      item: "text-[#000000] font-['CircularStdBook'] text-[18px] text-left leading-[100%] gap-x-[10px] text-opacity-50 border-b border-[#000000] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#fff8eb] border-[#000000] !pb-8",
      titles: "text-[#000000] font-['CircularStdBook'] text-[34px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#333333] font-['CircularStdBook'] text-[15px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['CircularStdBook'] text-[34px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-transparent border border-[#000000]",
          mediaContainer: "w-full sm:w-[256px] h-[256px] relative",
          media: "w-full h-[256px] object-cover",
          placeholderMedia: "w-full h-[256px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title: "text-[#000000] font-['CircularStdBook'] text-[18px] text-left leading-[100%]",
          subtitle:
            "text-[#333333] font-['CircularStdBook'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['CircularStdBook'] text-[34px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-transparent border border-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 h-[180px] relative",
          media: "w-full h-[180px] object-cover",
          placeholderMedia: "w-full h-[180px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title: "text-[#000000] font-['CircularStdBook'] text-[18px] text-left leading-[100%]",
          subtitle:
            "text-[#333333] font-['CircularStdBook'] text-[12px] text-left leading-[130%] mt-2",
          location:
            "text-[#333333] font-['CircularStdBook'] text-[12px] text-left leading-[130%] mt-1",
          date: "text-[#333333] font-['CircularStdBook'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['CircularStdBook'] text-[28px] text-left leading-[100%]",
        text: "text-[#000000] font-['CircularStdBook'] text-[16px] text-left leading-[130%]",
        customShopImageStyle: "border border-[#ffffff]",
        sectionTitle:
          "text-[#000000] font-['CircularStdBook'] text-[34px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop:
        "https://media.werz.at/community-assets/losgehtsberlin/web-background-non-member.jpg",
      bgMobile:
        "https://media.werz.at/community-assets/losgehtsberlin/web-background-non-member.jpg",
      bgColor: "#fff8eb",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#fff8eb]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#000000]",
        name: "text-[#000000] font-['CircularStdBook'] text-[34px] leading-[100%] text-center text-center mt-4 mb-1",
        location:
          "font-['CircularStdBook'] leading-[100%] text-[16px] text-center text-center mb-2",
        description:
          "text-[#000000] font-['CircularStdBook'] text-[16px] leading-[130%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#000000] border border-[#000000] rounded-lg px-3 py-3 text-[#fff8eb] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#fff8eb] border border-[#000000] text-[#000000] font-['CircularStdBook'] text-[16px] leading-[130%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#fff8eb] border border-[#000000]",
          title: "font-['CircularStdBook'] leading-[100%] text-[16px] text-left text-center mb-1",
          text: "text-[#000000] font-['CircularStdBook'] text-[16px] leading-[130%] text-center text-center",
          button:
            "bg-[#000000] border border-[#000000] rounded-lg px-3 py-3 text-[#fff8eb] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#fff8eb] border border-[#000000]",
          duration:
            "text-[#333333] font-['CircularStdBook'] text-[12px] leading-[130%] mt-2 text-left",
          name: "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#fff8eb] border border-[#000000]",
          name: "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#fff8eb] border border-[#000000] font-['CircularStdBook'] leading-[100%] text-[14px] text-center",
          duration:
            "text-[#333333] font-['CircularStdBook'] text-[12px] leading-[130%] mt-2 text-left",
          location:
            "text-[#333333] font-['CircularStdBook'] text-[12px] leading-[130%] mt-2 text-left",
          button:
            "bg-[#000000] border border-[#000000] rounded-lg px-3 py-3 text-[#fff8eb] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#000000]",
            name: "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#000000] font-['CircularStdBook'] leading-[100%] mt-1 text-[14px] text-left",
            link: "text-[#333333] font-['CircularStdBook'] text-[12px] leading-[130%] mt-2 text-left",
            status: "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[14px] text-left",
            button:
              "bg-[#000000] border border-[#000000] rounded-lg px-3 py-3 text-[#fff8eb] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['CircularStdBook'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#fff8eb] border border-[#000000] text-[#000000] font-['CircularStdBook'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#fff8eb] border border-[#000000]",
          name: "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created:
            "text-[#333333] font-['CircularStdBook'] text-[12px] leading-[130%] mt-2 text-left",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        seeAllNews:
          "text-[#000000] font-['CircularStdBook'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#fff8eb] border border-[#000000] text-[#000000] font-['CircularStdBook'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#fff8eb] border border-[#000000]",
          coverUrl: "overflow-hidden m-2 border border-[#000000]",
          duration:
            "text-[#333333] font-['CircularStdBook'] text-[12px] leading-[130%] mt-2 text-left",
          liveType:
            "text-[#333333] font-['CircularStdBook'] text-[12px] leading-[130%] mt-2 text-left",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#000000",
          start:
            "text-[#333333] font-['CircularStdBook'] text-[12px] leading-[130%] mt-2 text-left",
          title:
            "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['CircularStdBook'] text-[16px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#fff8eb] border border-[#000000] text-[#000000] font-['CircularStdBook'] text-[16px] leading-[130%] text-center",
        header:
          "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#fff8eb] border border-[#000000]",
          name: "text-[#000000] font-['CircularStdBook'] leading-[100%] text-[16px] text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#000000]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#333333] font-['CircularStdBook'] text-[12px] leading-[130%] mt-2 text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#fff8eb] border-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 border border-[#ffffff]",
        title: "text-[#000000] font-['CircularStdBook'] text-[34px] text-left leading-[100%]",
        subtitle:
          "text-[#333333] font-['CircularStdBook'] text-[15px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#ffffff] rounded-lg px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#fff8eb] font-['OCRATributeW01-RegularMonoRegular'] !text-[16px] uppercase text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[130%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['CircularStdBook'] text-[28px] text-left leading-[100%]",
        text: "text-[#000000] font-['CircularStdBook'] text-[15px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['CircularStdBook'] text-[28px] text-left leading-[100%]",
        text: "text-[#000000] font-['CircularStdBook'] text-[15px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['CircularStdBook'] text-[28px] text-left leading-[100%]",
        text: "text-[#000000] font-['CircularStdBook'] text-[15px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['CircularStdBook'] text-[34px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 pb-4 sm:pb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#fff8eb] border-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#000000] border border-[#000000] rounded-lg px-3 py-3 text-[#fff8eb] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto bg-transparent border-b border-[#000000] mb-4 p-4 overflow-hidden",
          media: "!hidden",
          name: "text-[#000000] font-['CircularStdBook'] text-[18px] text-left leading-[100%]",
          description:
            "text-[#333333] font-['CircularStdBook'] text-[15px] text-left leading-[130%] !mt-1 flex flex-row",
          price:
            "text-[#333333] font-['CircularStdBook'] text-[18px] text-left leading-[100%] !mt-1",
          quantity:
            "text-[#fff8eb] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left leading-[100%]",
          status: "text-[#333333] font-['CircularStdBook'] text-[18px] text-left leading-[100%]",
          counterContainer:
            "bg-[#000000] border border-[#000000] rounded-lg !px-3 !py-3 gap-x-4 !w-fit !h-[43px]",
          button:
            "!bg-[#000000] border border-[#000000] rounded-lg px-3 py-3 text-[#fff8eb] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left !w-fit",
          plusMinusColor: "#fff8eb",
        },
      },
    },
  },
}

export default losgehtsberlin
